import {
  AnalyticsActionTypes,
  AnalyticsActionUnion,
  OverrideAnalyticsCoupon
} from './actions';
import { AnalyticsStoreState } from './state';
import { AnalyticsDurationIdentifier } from '../../types/analytics.types';
import { isMatch } from 'lodash';

export const initialAnalyticsState: AnalyticsStoreState = {
  latest: {
    data: null,
    dealId: null,
    error: null,
    errorCode: null,
    loaded: false,
    loading: false,
    unloadedOverrides: false
  },
  overriddenCoupons: {},
  selectedDuration: AnalyticsDurationIdentifier.Effective
};

const hasUnloadedOverrides = (
  state: AnalyticsStoreState,
  action: OverrideAnalyticsCoupon
) => !isMatch(state.overriddenCoupons, action.payload);

export function analyticsReducer(
  state: AnalyticsStoreState = initialAnalyticsState,
  action: AnalyticsActionUnion
): AnalyticsStoreState {
  switch (action.type) {
    case AnalyticsActionTypes.LoadAnalytics:
      return {
        ...state,
        latest: {
          ...state.latest,
          dealId: action.payload.dealId,
          error: null,
          errorCode: null,
          loaded: false,
          loading: true,
          unloadedOverrides: false
        }
      };
    case AnalyticsActionTypes.LoadBidAnalytics:
      return {
        ...state,
        latest: {
          ...state.latest,
          dealId: action.payload.dealId,
          error: null,
          errorCode: null,
          loaded: false,
          loading: true,
          unloadedOverrides: false
        }
      };
    case AnalyticsActionTypes.LoadAnalyticsFail:
      return {
        ...state,
        latest: {
          ...state.latest,
          error: action.payload.error,
          errorCode: action.payload.errorCode,
          loaded: false,
          loading: false
        }
      };
    case AnalyticsActionTypes.LoadAnalyticsSuccess:
      return {
        ...state,
        latest: {
          ...state.latest,
          data: action.payload.data,
          loaded: true,
          loading: false
        }
      };
    case AnalyticsActionTypes.LoadBidAnalyticsSuccess:
      return state.latest.data
        ? {
            ...state,
            latest: {
              ...state.latest,
              data: {
                maturities:
                  action.payload.data.maturities && state.latest.data.maturities
                    ? state.latest.data.maturities.concat(
                        ...action.payload.data.maturities
                      )
                    : state.latest.data.maturities
                    ? state.latest.data.maturities
                    : action.payload.data.maturities
                    ? action.payload.data.maturities
                    : []
              },
              loaded: true,
              loading: false
            }
          }
        : {
            ...state,
            latest: {
              ...state.latest,
              data: {
                maturities: action.payload.data.maturities
                  ? action.payload.data.maturities
                  : []
              },
              loaded: true,
              loading: false
            }
          };
    case AnalyticsActionTypes.LoadBidAnalyticsFail:
      return {
        ...state,
        latest: {
          ...state.latest,
          error: action.payload.error,
          errorCode: action.payload.errorCode,
          loaded: false,
          loading: false
        }
      };

    case AnalyticsActionTypes.SelectAnalyticsDuration:
      return {
        ...state,
        selectedDuration: action.payload.identifier
      };
    case AnalyticsActionTypes.OverrideAnalyticsCoupon:
      return {
        ...state,
        latest: {
          ...state.latest,
          unloadedOverrides: hasUnloadedOverrides(state, action)
        },
        overriddenCoupons: {
          ...state.overriddenCoupons,
          ...action.payload
        }
      };
    default:
      return state;
  }
}
